import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { Exclusion } from '../exclusions.models';
import { StickyOptions } from 'common/components/table/tableTypes';
import ExclusionsTableActions from './exclusions-table-actions';

const columnHelper = createColumnHelper<Exclusion>();

export const getExclusionsColumnDefs = (isSuperUser: boolean) => {
  const columnDefs = [
    columnHelper.accessor((row) => row.additionalInformation, {
      id: 'AdditionalInformation',
      header: () => 'Additional Information',
      enableColumnFilter: false,
      cell: (info) => (
        <div className="text-sm truncate" title={info.getValue()}>
          {info.getValue()}
        </div>
      ),
      size: 150
    }),
    columnHelper.accessor((row) => row.exclusionCategory, {
      id: 'Category',
      header: () => 'Category',
      cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>,
      size: 20
    }),
    columnHelper.accessor((row) => row.exclusionType, {
      id: 'Type',
      header: () => 'Type',
      cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>,
      size: 60
    })
  ];

  if (isSuperUser) {
    columnDefs.push(
      columnHelper.accessor((row) => row.exclusionMatchTarget, {
        id: 'MatchTarget',
        header: () => 'Match Target',
        cell: (info) => (
          <div className="text-sm truncate">{info.getValue()}</div>
        ),
        size: 45
      }) as ColumnDef<Exclusion, unknown>
    );
  }

  return columnDefs.concat([
    columnHelper.accessor((row) => row.ruleMatchType, {
      id: 'RuleMatchType',
      header: () => 'Rule Match Type',
      cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>,
      size: 45
    }),
    columnHelper.accessor((row) => row.value, {
      id: 'Value',
      header: () => 'Match Value',
      cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>,
      size: 50
    }),

    columnHelper.accessor((row) => row.createdDateTime, {
      id: 'Created Date',
      header: () => 'Created Date',
      enableColumnFilter: false,
      cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>,
      size: 50
    }),
    columnHelper.accessor((row) => row.exclusionLevel, {
      id: 'Level',
      header: () => 'Level',
      cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>,
      size: 20
    }),
    columnHelper.accessor(
      (row) =>
        `${row.exclusionLevel}-${row.exclusionCategory}-${row.exclusionType}-${row.exclusionMatchTarget}-${row.ruleMatchType}-${row.additionalInformation}-${row.createdDateTime}-${row.value}`,
      {
        id: 'actions',
        header: () => 'Actions',
        enableColumnFilter: false,
        cell: (info) => (
          <ExclusionsTableActions exclusion={info.row.original} />
        ),
        size: 5,
        meta: {
          stickyOptions: {
            isEnabled: true,
            side: 'right'
          } as StickyOptions
        }
      }
    )
  ] as ColumnDef<Exclusion, unknown>[]);
};
